import React, { useState, useEffect } from "react";
import "./Header.css";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <nav className="nav">
          <div className="logo">
            <img src="/images/spa-logo.png" alt="SPA Holdings" />
          </div>

          <div className={`nav-menu ${isMobileMenuOpen ? "active" : ""}`}>
            <a
              href="#home"
              className="nav-link"
              onClick={(e) => scrollToSection(e, "home")}
            >
              Home
            </a>
            <a
              href="#services"
              className="nav-link"
              onClick={(e) => scrollToSection(e, "services")}
            >
              Services
            </a>
            <a
              href="#ai-services"
              className="nav-link"
              onClick={(e) => scrollToSection(e, "ai-services")}
            >
              AI & Technology
            </a>
            <a
              href="#consulting"
              className="nav-link"
              onClick={(e) => scrollToSection(e, "consulting")}
            >
              Consulting
            </a>
            <a
              href="#portfolio"
              className="nav-link"
              onClick={(e) => scrollToSection(e, "portfolio")}
            >
              Portfolio
            </a>
            <a
              href="#contact"
              className="nav-link"
              onClick={(e) => scrollToSection(e, "contact")}
            >
              Contact
            </a>
          </div>

          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
